import { create } from 'zustand';

/**
 * Состояние палитры ⌘K: открыта ли и какие действия ей подставил
 * текущий экран.
 *
 * Действие «создать задачу» умеет только доска: у неё есть проект, доска и
 * первая колонка. Пока доска на экране, она регистрирует здесь функцию;
 * ушла — снимает. Палитра показывает пункт, только если функция есть.
 */
interface PaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
  /** Создать задачу с таким названием и вернуть её ключ. */
  createTask: ((title: string) => Promise<string>) | null;
  setCreateTask: (fn: PaletteState['createTask']) => void;
}

export const usePalette = create<PaletteState>((set) => ({
  open: false,
  setOpen: (open) => {
    set({ open });
  },
  createTask: null,
  setCreateTask: (createTask) => {
    set({ createTask });
  },
}));

/** Открыть палитру откуда угодно — из кнопки в шапке или по ⌘K. */
export function openPalette(): void {
  usePalette.getState().setOpen(true);
}
